module.exports = __webpack_public_path__ + "img/card.6b8c5f24.svg";